<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <span :class="['expensa-pill', `expensa-pill--${tone.toLowerCase()}`]">
    {{ label }}
  </span>
</template>

<script>
// Etichetta colorata dello stato di una nota o di una spesa.
export default {
  name: 'ExpensaStatusPill',
  props: {
    label: {
      type: String,
      required: true,
    },
    // Stato della nota (DRAFT...), AWAITING per "in attesa di finance"
    // oppure dello stato di una spesa (READY, NEEDS_REVIEW).
    tone: {
      type: String,
      default: 'DRAFT',
    },
  },
};
</script>

<style scoped lang="scss">
.expensa-pill {
  display: inline-block;
  padding: 0.15rem 0.7rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  background: #e8eaef;
  color: #64728c;
  &--submitted,
  &--awaiting,
  &--needs_review {
    background: #fff3d6;
    color: #8a5a00;
  }
  &--approved,
  &--ready {
    background: #dcf3e4;
    color: #1f7a45;
  }
  &--rejected {
    background: #fde0dd;
    color: #b3261e;
  }
  &--reimbursed {
    background: #dbe9fb;
    color: #1d5fb4;
  }
}
</style>
